export enum Timezone {
    AfricaAbidjan = 'africa/abidjan',
    AfricaAccra = 'africa/accra',
    AfricaAddisAbaba = 'africa/addis_ababa',
    AfricaAlgiers = 'africa/algiers',
    AfricaAsmara = 'africa/asmara',
    AfricaBamako = 'africa/bamako',
    AfricaBangui = 'africa/bangui',
    AfricaBanjul = 'africa/banjul',
    AfricaBissau = 'africa/bissau',
    AfricaBlantyre = 'africa/blantyre',
    AfricaBrazzaville = 'africa/brazzaville',
    AfricaBujumbura = 'africa/bujumbura',
    AfricaCairo = 'africa/cairo',
    AfricaCasablanca = 'africa/casablanca',
    AfricaCeuta = 'africa/ceuta',
    AfricaConakry = 'africa/conakry',
    AfricaDakar = 'africa/dakar',
    AfricaDarEsSalaam = 'africa/dar_es_salaam',
    AfricaDjibouti = 'africa/djibouti',
    AfricaDouala = 'africa/douala',
    AfricaElAaiun = 'africa/el_aaiun',
    AfricaFreetown = 'africa/freetown',
    AfricaGaborone = 'africa/gaborone',
    AfricaHarare = 'africa/harare',
    AfricaJohannesburg = 'africa/johannesburg',
    AfricaJuba = 'africa/juba',
    AfricaKampala = 'africa/kampala',
    AfricaKhartoum = 'africa/khartoum',
    AfricaKigali = 'africa/kigali',
    AfricaKinshasa = 'africa/kinshasa',
    AfricaLagos = 'africa/lagos',
    AfricaLibreville = 'africa/libreville',
    AfricaLome = 'africa/lome',
    AfricaLuanda = 'africa/luanda',
    AfricaLubumbashi = 'africa/lubumbashi',
    AfricaLusaka = 'africa/lusaka',
    AfricaMalabo = 'africa/malabo',
    AfricaMaputo = 'africa/maputo',
    AfricaMaseru = 'africa/maseru',
    AfricaMbabane = 'africa/mbabane',
    AfricaMogadishu = 'africa/mogadishu',
    AfricaMonrovia = 'africa/monrovia',
    AfricaNairobi = 'africa/nairobi',
    AfricaNdjamena = 'africa/ndjamena',
    AfricaNiamey = 'africa/niamey',
    AfricaNouakchott = 'africa/nouakchott',
    AfricaOuagadougou = 'africa/ouagadougou',
    AfricaPortonovo = 'africa/porto-novo',
    AfricaSaoTome = 'africa/sao_tome',
    AfricaTripoli = 'africa/tripoli',
    AfricaTunis = 'africa/tunis',
    AfricaWindhoek = 'africa/windhoek',
    AmericaAdak = 'america/adak',
    AmericaAnchorage = 'america/anchorage',
    AmericaAnguilla = 'america/anguilla',
    AmericaAntigua = 'america/antigua',
    AmericaAraguaina = 'america/araguaina',
    AmericaArgentinaBuenosAires = 'america/argentina/buenos_aires',
    AmericaArgentinaCatamarca = 'america/argentina/catamarca',
    AmericaArgentinaCordoba = 'america/argentina/cordoba',
    AmericaArgentinaJujuy = 'america/argentina/jujuy',
    AmericaArgentinaLaRioja = 'america/argentina/la_rioja',
    AmericaArgentinaMendoza = 'america/argentina/mendoza',
    AmericaArgentinaRioGallegos = 'america/argentina/rio_gallegos',
    AmericaArgentinaSalta = 'america/argentina/salta',
    AmericaArgentinaSanJuan = 'america/argentina/san_juan',
    AmericaArgentinaSanLuis = 'america/argentina/san_luis',
    AmericaArgentinaTucuman = 'america/argentina/tucuman',
    AmericaArgentinaUshuaia = 'america/argentina/ushuaia',
    AmericaAruba = 'america/aruba',
    AmericaAsuncion = 'america/asuncion',
    AmericaAtikokan = 'america/atikokan',
    AmericaBahia = 'america/bahia',
    AmericaBahiaBanderas = 'america/bahia_banderas',
    AmericaBarbados = 'america/barbados',
    AmericaBelem = 'america/belem',
    AmericaBelize = 'america/belize',
    AmericaBlancsablon = 'america/blanc-sablon',
    AmericaBoaVista = 'america/boa_vista',
    AmericaBogota = 'america/bogota',
    AmericaBoise = 'america/boise',
    AmericaCambridgeBay = 'america/cambridge_bay',
    AmericaCampoGrande = 'america/campo_grande',
    AmericaCancun = 'america/cancun',
    AmericaCaracas = 'america/caracas',
    AmericaCayenne = 'america/cayenne',
    AmericaCayman = 'america/cayman',
    AmericaChicago = 'america/chicago',
    AmericaChihuahua = 'america/chihuahua',
    AmericaCiudadJuarez = 'america/ciudad_juarez',
    AmericaCostaRica = 'america/costa_rica',
    AmericaCoyhaique = 'america/coyhaique',
    AmericaCreston = 'america/creston',
    AmericaCuiaba = 'america/cuiaba',
    AmericaCuracao = 'america/curacao',
    AmericaDanmarkshavn = 'america/danmarkshavn',
    AmericaDawson = 'america/dawson',
    AmericaDawsonCreek = 'america/dawson_creek',
    AmericaDenver = 'america/denver',
    AmericaDetroit = 'america/detroit',
    AmericaDominica = 'america/dominica',
    AmericaEdmonton = 'america/edmonton',
    AmericaEirunepe = 'america/eirunepe',
    AmericaElSalvador = 'america/el_salvador',
    AmericaFortNelson = 'america/fort_nelson',
    AmericaFortaleza = 'america/fortaleza',
    AmericaGlaceBay = 'america/glace_bay',
    AmericaGooseBay = 'america/goose_bay',
    AmericaGrandTurk = 'america/grand_turk',
    AmericaGrenada = 'america/grenada',
    AmericaGuadeloupe = 'america/guadeloupe',
    AmericaGuatemala = 'america/guatemala',
    AmericaGuayaquil = 'america/guayaquil',
    AmericaGuyana = 'america/guyana',
    AmericaHalifax = 'america/halifax',
    AmericaHavana = 'america/havana',
    AmericaHermosillo = 'america/hermosillo',
    AmericaIndianaIndianapolis = 'america/indiana/indianapolis',
    AmericaIndianaKnox = 'america/indiana/knox',
    AmericaIndianaMarengo = 'america/indiana/marengo',
    AmericaIndianaPetersburg = 'america/indiana/petersburg',
    AmericaIndianaTellCity = 'america/indiana/tell_city',
    AmericaIndianaVevay = 'america/indiana/vevay',
    AmericaIndianaVincennes = 'america/indiana/vincennes',
    AmericaIndianaWinamac = 'america/indiana/winamac',
    AmericaInuvik = 'america/inuvik',
    AmericaIqaluit = 'america/iqaluit',
    AmericaJamaica = 'america/jamaica',
    AmericaJuneau = 'america/juneau',
    AmericaKentuckyLouisville = 'america/kentucky/louisville',
    AmericaKentuckyMonticello = 'america/kentucky/monticello',
    AmericaKralendijk = 'america/kralendijk',
    AmericaLaPaz = 'america/la_paz',
    AmericaLima = 'america/lima',
    AmericaLosAngeles = 'america/los_angeles',
    AmericaLowerPrinces = 'america/lower_princes',
    AmericaMaceio = 'america/maceio',
    AmericaManagua = 'america/managua',
    AmericaManaus = 'america/manaus',
    AmericaMarigot = 'america/marigot',
    AmericaMartinique = 'america/martinique',
    AmericaMatamoros = 'america/matamoros',
    AmericaMazatlan = 'america/mazatlan',
    AmericaMenominee = 'america/menominee',
    AmericaMerida = 'america/merida',
    AmericaMetlakatla = 'america/metlakatla',
    AmericaMexicoCity = 'america/mexico_city',
    AmericaMiquelon = 'america/miquelon',
    AmericaMoncton = 'america/moncton',
    AmericaMonterrey = 'america/monterrey',
    AmericaMontevideo = 'america/montevideo',
    AmericaMontserrat = 'america/montserrat',
    AmericaNassau = 'america/nassau',
    AmericaNewYork = 'america/new_york',
    AmericaNome = 'america/nome',
    AmericaNoronha = 'america/noronha',
    AmericaNorthDakotaBeulah = 'america/north_dakota/beulah',
    AmericaNorthDakotaCenter = 'america/north_dakota/center',
    AmericaNorthDakotaNewSalem = 'america/north_dakota/new_salem',
    AmericaNuuk = 'america/nuuk',
    AmericaOjinaga = 'america/ojinaga',
    AmericaPanama = 'america/panama',
    AmericaParamaribo = 'america/paramaribo',
    AmericaPhoenix = 'america/phoenix',
    AmericaPortauprince = 'america/port-au-prince',
    AmericaPortOfSpain = 'america/port_of_spain',
    AmericaPortoVelho = 'america/porto_velho',
    AmericaPuertoRico = 'america/puerto_rico',
    AmericaPuntaArenas = 'america/punta_arenas',
    AmericaRankinInlet = 'america/rankin_inlet',
    AmericaRecife = 'america/recife',
    AmericaRegina = 'america/regina',
    AmericaResolute = 'america/resolute',
    AmericaRioBranco = 'america/rio_branco',
    AmericaSantarem = 'america/santarem',
    AmericaSantiago = 'america/santiago',
    AmericaSantoDomingo = 'america/santo_domingo',
    AmericaSaoPaulo = 'america/sao_paulo',
    AmericaScoresbysund = 'america/scoresbysund',
    AmericaSitka = 'america/sitka',
    AmericaStBarthelemy = 'america/st_barthelemy',
    AmericaStJohns = 'america/st_johns',
    AmericaStKitts = 'america/st_kitts',
    AmericaStLucia = 'america/st_lucia',
    AmericaStThomas = 'america/st_thomas',
    AmericaStVincent = 'america/st_vincent',
    AmericaSwiftCurrent = 'america/swift_current',
    AmericaTegucigalpa = 'america/tegucigalpa',
    AmericaThule = 'america/thule',
    AmericaTijuana = 'america/tijuana',
    AmericaToronto = 'america/toronto',
    AmericaTortola = 'america/tortola',
    AmericaVancouver = 'america/vancouver',
    AmericaWhitehorse = 'america/whitehorse',
    AmericaWinnipeg = 'america/winnipeg',
    AmericaYakutat = 'america/yakutat',
    AntarcticaCasey = 'antarctica/casey',
    AntarcticaDavis = 'antarctica/davis',
    AntarcticaDumontdurville = 'antarctica/dumontdurville',
    AntarcticaMacquarie = 'antarctica/macquarie',
    AntarcticaMawson = 'antarctica/mawson',
    AntarcticaMcmurdo = 'antarctica/mcmurdo',
    AntarcticaPalmer = 'antarctica/palmer',
    AntarcticaRothera = 'antarctica/rothera',
    AntarcticaSyowa = 'antarctica/syowa',
    AntarcticaTroll = 'antarctica/troll',
    AntarcticaVostok = 'antarctica/vostok',
    ArcticLongyearbyen = 'arctic/longyearbyen',
    AsiaAden = 'asia/aden',
    AsiaAlmaty = 'asia/almaty',
    AsiaAmman = 'asia/amman',
    AsiaAnadyr = 'asia/anadyr',
    AsiaAqtau = 'asia/aqtau',
    AsiaAqtobe = 'asia/aqtobe',
    AsiaAshgabat = 'asia/ashgabat',
    AsiaAtyrau = 'asia/atyrau',
    AsiaBaghdad = 'asia/baghdad',
    AsiaBahrain = 'asia/bahrain',
    AsiaBaku = 'asia/baku',
    AsiaBangkok = 'asia/bangkok',
    AsiaBarnaul = 'asia/barnaul',
    AsiaBeirut = 'asia/beirut',
    AsiaBishkek = 'asia/bishkek',
    AsiaBrunei = 'asia/brunei',
    AsiaChita = 'asia/chita',
    AsiaColombo = 'asia/colombo',
    AsiaDamascus = 'asia/damascus',
    AsiaDhaka = 'asia/dhaka',
    AsiaDili = 'asia/dili',
    AsiaDubai = 'asia/dubai',
    AsiaDushanbe = 'asia/dushanbe',
    AsiaFamagusta = 'asia/famagusta',
    AsiaGaza = 'asia/gaza',
    AsiaHebron = 'asia/hebron',
    AsiaHoChiMinh = 'asia/ho_chi_minh',
    AsiaHongKong = 'asia/hong_kong',
    AsiaHovd = 'asia/hovd',
    AsiaIrkutsk = 'asia/irkutsk',
    AsiaJakarta = 'asia/jakarta',
    AsiaJayapura = 'asia/jayapura',
    AsiaJerusalem = 'asia/jerusalem',
    AsiaKabul = 'asia/kabul',
    AsiaKamchatka = 'asia/kamchatka',
    AsiaKarachi = 'asia/karachi',
    AsiaKathmandu = 'asia/kathmandu',
    AsiaKhandyga = 'asia/khandyga',
    AsiaKolkata = 'asia/kolkata',
    AsiaKrasnoyarsk = 'asia/krasnoyarsk',
    AsiaKualaLumpur = 'asia/kuala_lumpur',
    AsiaKuching = 'asia/kuching',
    AsiaKuwait = 'asia/kuwait',
    AsiaMacau = 'asia/macau',
    AsiaMagadan = 'asia/magadan',
    AsiaMakassar = 'asia/makassar',
    AsiaManila = 'asia/manila',
    AsiaMuscat = 'asia/muscat',
    AsiaNicosia = 'asia/nicosia',
    AsiaNovokuznetsk = 'asia/novokuznetsk',
    AsiaNovosibirsk = 'asia/novosibirsk',
    AsiaOmsk = 'asia/omsk',
    AsiaOral = 'asia/oral',
    AsiaPhnomPenh = 'asia/phnom_penh',
    AsiaPontianak = 'asia/pontianak',
    AsiaPyongyang = 'asia/pyongyang',
    AsiaQatar = 'asia/qatar',
    AsiaQostanay = 'asia/qostanay',
    AsiaQyzylorda = 'asia/qyzylorda',
    AsiaRiyadh = 'asia/riyadh',
    AsiaSakhalin = 'asia/sakhalin',
    AsiaSamarkand = 'asia/samarkand',
    AsiaSeoul = 'asia/seoul',
    AsiaShanghai = 'asia/shanghai',
    AsiaSingapore = 'asia/singapore',
    AsiaSrednekolymsk = 'asia/srednekolymsk',
    AsiaTaipei = 'asia/taipei',
    AsiaTashkent = 'asia/tashkent',
    AsiaTbilisi = 'asia/tbilisi',
    AsiaTehran = 'asia/tehran',
    AsiaThimphu = 'asia/thimphu',
    AsiaTokyo = 'asia/tokyo',
    AsiaTomsk = 'asia/tomsk',
    AsiaUlaanbaatar = 'asia/ulaanbaatar',
    AsiaUrumqi = 'asia/urumqi',
    AsiaUstnera = 'asia/ust-nera',
    AsiaVientiane = 'asia/vientiane',
    AsiaVladivostok = 'asia/vladivostok',
    AsiaYakutsk = 'asia/yakutsk',
    AsiaYangon = 'asia/yangon',
    AsiaYekaterinburg = 'asia/yekaterinburg',
    AsiaYerevan = 'asia/yerevan',
    AtlanticAzores = 'atlantic/azores',
    AtlanticBermuda = 'atlantic/bermuda',
    AtlanticCanary = 'atlantic/canary',
    AtlanticCapeVerde = 'atlantic/cape_verde',
    AtlanticFaroe = 'atlantic/faroe',
    AtlanticMadeira = 'atlantic/madeira',
    AtlanticReykjavik = 'atlantic/reykjavik',
    AtlanticSouthGeorgia = 'atlantic/south_georgia',
    AtlanticStHelena = 'atlantic/st_helena',
    AtlanticStanley = 'atlantic/stanley',
    AustraliaAdelaide = 'australia/adelaide',
    AustraliaBrisbane = 'australia/brisbane',
    AustraliaBrokenHill = 'australia/broken_hill',
    AustraliaDarwin = 'australia/darwin',
    AustraliaEucla = 'australia/eucla',
    AustraliaHobart = 'australia/hobart',
    AustraliaLindeman = 'australia/lindeman',
    AustraliaLordHowe = 'australia/lord_howe',
    AustraliaMelbourne = 'australia/melbourne',
    AustraliaPerth = 'australia/perth',
    AustraliaSydney = 'australia/sydney',
    EuropeAmsterdam = 'europe/amsterdam',
    EuropeAndorra = 'europe/andorra',
    EuropeAstrakhan = 'europe/astrakhan',
    EuropeAthens = 'europe/athens',
    EuropeBelgrade = 'europe/belgrade',
    EuropeBerlin = 'europe/berlin',
    EuropeBratislava = 'europe/bratislava',
    EuropeBrussels = 'europe/brussels',
    EuropeBucharest = 'europe/bucharest',
    EuropeBudapest = 'europe/budapest',
    EuropeBusingen = 'europe/busingen',
    EuropeChisinau = 'europe/chisinau',
    EuropeCopenhagen = 'europe/copenhagen',
    EuropeDublin = 'europe/dublin',
    EuropeGibraltar = 'europe/gibraltar',
    EuropeGuernsey = 'europe/guernsey',
    EuropeHelsinki = 'europe/helsinki',
    EuropeIsleOfMan = 'europe/isle_of_man',
    EuropeIstanbul = 'europe/istanbul',
    EuropeJersey = 'europe/jersey',
    EuropeKaliningrad = 'europe/kaliningrad',
    EuropeKirov = 'europe/kirov',
    EuropeKyiv = 'europe/kyiv',
    EuropeLisbon = 'europe/lisbon',
    EuropeLjubljana = 'europe/ljubljana',
    EuropeLondon = 'europe/london',
    EuropeLuxembourg = 'europe/luxembourg',
    EuropeMadrid = 'europe/madrid',
    EuropeMalta = 'europe/malta',
    EuropeMariehamn = 'europe/mariehamn',
    EuropeMinsk = 'europe/minsk',
    EuropeMonaco = 'europe/monaco',
    EuropeMoscow = 'europe/moscow',
    EuropeOslo = 'europe/oslo',
    EuropeParis = 'europe/paris',
    EuropePodgorica = 'europe/podgorica',
    EuropePrague = 'europe/prague',
    EuropeRiga = 'europe/riga',
    EuropeRome = 'europe/rome',
    EuropeSamara = 'europe/samara',
    EuropeSanMarino = 'europe/san_marino',
    EuropeSarajevo = 'europe/sarajevo',
    EuropeSaratov = 'europe/saratov',
    EuropeSimferopol = 'europe/simferopol',
    EuropeSkopje = 'europe/skopje',
    EuropeSofia = 'europe/sofia',
    EuropeStockholm = 'europe/stockholm',
    EuropeTallinn = 'europe/tallinn',
    EuropeTirane = 'europe/tirane',
    EuropeUlyanovsk = 'europe/ulyanovsk',
    EuropeVaduz = 'europe/vaduz',
    EuropeVatican = 'europe/vatican',
    EuropeVienna = 'europe/vienna',
    EuropeVilnius = 'europe/vilnius',
    EuropeVolgograd = 'europe/volgograd',
    EuropeWarsaw = 'europe/warsaw',
    EuropeZagreb = 'europe/zagreb',
    EuropeZurich = 'europe/zurich',
    IndianAntananarivo = 'indian/antananarivo',
    IndianChagos = 'indian/chagos',
    IndianChristmas = 'indian/christmas',
    IndianCocos = 'indian/cocos',
    IndianComoro = 'indian/comoro',
    IndianKerguelen = 'indian/kerguelen',
    IndianMahe = 'indian/mahe',
    IndianMaldives = 'indian/maldives',
    IndianMauritius = 'indian/mauritius',
    IndianMayotte = 'indian/mayotte',
    IndianReunion = 'indian/reunion',
    PacificApia = 'pacific/apia',
    PacificAuckland = 'pacific/auckland',
    PacificBougainville = 'pacific/bougainville',
    PacificChatham = 'pacific/chatham',
    PacificChuuk = 'pacific/chuuk',
    PacificEaster = 'pacific/easter',
    PacificEfate = 'pacific/efate',
    PacificFakaofo = 'pacific/fakaofo',
    PacificFiji = 'pacific/fiji',
    PacificFunafuti = 'pacific/funafuti',
    PacificGalapagos = 'pacific/galapagos',
    PacificGambier = 'pacific/gambier',
    PacificGuadalcanal = 'pacific/guadalcanal',
    PacificGuam = 'pacific/guam',
    PacificHonolulu = 'pacific/honolulu',
    PacificKanton = 'pacific/kanton',
    PacificKiritimati = 'pacific/kiritimati',
    PacificKosrae = 'pacific/kosrae',
    PacificKwajalein = 'pacific/kwajalein',
    PacificMajuro = 'pacific/majuro',
    PacificMarquesas = 'pacific/marquesas',
    PacificMidway = 'pacific/midway',
    PacificNauru = 'pacific/nauru',
    PacificNiue = 'pacific/niue',
    PacificNorfolk = 'pacific/norfolk',
    PacificNoumea = 'pacific/noumea',
    PacificPagoPago = 'pacific/pago_pago',
    PacificPalau = 'pacific/palau',
    PacificPitcairn = 'pacific/pitcairn',
    PacificPohnpei = 'pacific/pohnpei',
    PacificPortMoresby = 'pacific/port_moresby',
    PacificRarotonga = 'pacific/rarotonga',
    PacificSaipan = 'pacific/saipan',
    PacificTahiti = 'pacific/tahiti',
    PacificTarawa = 'pacific/tarawa',
    PacificTongatapu = 'pacific/tongatapu',
    PacificWake = 'pacific/wake',
    PacificWallis = 'pacific/wallis',
    Utc = 'utc',
}